import React, { useState, useEffect, useContext } from "react";
import FHomeCard from "../../components/FHomeCard/FHomeCard";
import { useHome } from "./hooks/useHome";
import { AuthContext } from "../../context/AuthContext";
import { useContacts } from "../../hooks/useContacts";
import { getBalance } from "../../api/currency";
import { size } from "lodash";
import { QrcodeIcon } from "@heroicons/react/outline";
import { AlertModalKyc } from "../../components/AlertModalKyc/AlertModalKyc";

import "./style/HomeStyle.css";
import VectorIcons from "../../components/VectorIcons/VectorIcons";
import FContainer from "../../components/FContainer/FContainer";
import { Tile } from "maplibre-gl";
import { useNotification } from "../../hooks/useNotification";

const Home = ({ param }) => {

  const { textLimite, textSaldo, textPendiente, route, _getBalance,
    spendNavigation, isRegisteredUser, refreshToken, setCallToAction
  } = useHome();
  const { notificationsSocket, setNotificationsSocket } = useContext(AuthContext);  

  const [visible, setVisible] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [saldo, setSaldo] = useState(0);
  const [limite, setLimite] = useState(0);
  const [pendiente, setPendiente] = useState(0);


  const { getContacts } = useContacts();

  
  useEffect(() => {
    if (!!notificationsSocket) {
      if (notificationsSocket.messageType === 'PUSH_RECIEVE_MONEY'){
        _getBalance(false);
      }
    }
  }, [notificationsSocket]);


  const { getNotification, notifications } = useNotification();
  const [totalPending, setTotalPending] = useState(0);

  useEffect(() => {
    const _getNotification = async () => {
      let res = await getNotification("PENDING", 1)

      if (res[0]) {
        setTotalPending(res.totalRecords)
      } else {
        setTotalPending(0)
      }
    };
    _getNotification();
    
    _getBalance();
  }, []);


  const getBalanceAccount = async () => {
    const { data } = await getBalance();
    if (size(data) > 0) {
      setSaldo(data.data.balances.availableAmount);
      setLimite(data.data.balances.limitAmount);
      setPendiente(data.data.balances.dueDate);
    } else {
      setSaldo([]);
      setLimite([]);
      setPendiente([]);
    }
  };

  const loadCurrency = async () => {
    setIsRefreshing(true);
    getBalanceAccount();
    setIsRefreshing(false);
  };

  const requestNavigation = () => {
    route("/CalcScreen");
  };

  const payNavigation = () => {
    route("/LoansScreen");
  };



  return (
    <>
      <FContainer>
        <div className="w-[97%]">
          {setCallToAction()}
        </div>
        <FHomeCard
          img={require("../../components/assets/images/pedir.png")}
          title="Pide Fiado"
          subTitle="Tu límite:"
          total={textLimite}
          onClick={() => {
            isRegisteredUser(requestNavigation);
          }}
        />
        <FHomeCard
          img={require("../../components/assets/images/gastar.png")}
          title="Gasta tu Fiado"
          subTitle="Tu disponible:"
          total={textSaldo}
          gradient={["#f10c8f", "#67274c"]}
          onClick={() => {
            isRegisteredUser(spendNavigation);
          }}
        />
        <FHomeCard
          img={require("../../components/assets/images/pagar.png")}
          title="Paga tu Fiado"
          subTitle="Tu deuda:"
          total={textPendiente}
          gradient={["#000000", "#7d7b7b"]}
          onClick={() => {
            isRegisteredUser(payNavigation);
          }}
        />
      </FContainer>
    </>
  );
};

export default Home;
